export default __webpack_public_path__ + "static/utero-8ac17ebf14e193f5f8727bf5e6ad06af.png";